import { createStore, combineReducers } from 'redux';

// Initial state
const initialAuthState = {
  access_token: {
    third_party_auth_token: ''
  }
};

const initialHomeState = {
  institute_id: 'IIFD001'
};

// Reducers
const authReducer = (state = initialAuthState, action) => {
  switch (action.type) {
    case 'LOGOUT':
      return initialAuthState;
    case 'SET_TOKEN':
      return {
        ...state,
        access_token: action.payload
      };
    default:
      return state;
  }
};

const homeReducer = (state = initialHomeState, action) => {
  switch (action.type) {
    case 'SET_INSTITUTE_ID':
      return {
        ...state,
        institute_id: action.payload
      };
    default:
      return state;
  }
};

// Combine reducers
const rootReducer = combineReducers({
  auth: authReducer,
  home: homeReducer
});

// Create store
const store = createStore(rootReducer);

export default store;
